import React from "react";
import { useSelector } from "react-redux";
// import Utility from "../../../helpers/utilityHelper";
import Spacing from "../../Spacing";
import SectionHeadingStyle3 from "../../SectionHeading/SectionHeadingStyle3";
import { Link } from "react-router-dom";
import { pageTitle } from "../../../helpers/PageTitle";
import {
  getSelectedDate,
  getSelectedSport,
  getSelectedCourt,
  getSelectedTime,
  getSelectedDuration,
  getSports,
  getCourtCharges
} from "../../../store/bookingSlice";
import Common from "../../../helpers/common";


export default function Checkout() {

  pageTitle("Checkout");
  // Redux selectors
  const selectedDate = useSelector(getSelectedDate);
  const selectedSport = useSelector(getSelectedSport);
  const selectedCourt = useSelector(getSelectedCourt);
  const selectedTime = useSelector(getSelectedTime);
  const selectedDuration = useSelector(getSelectedDuration);
  const courtCharges = useSelector(getCourtCharges);
  const sports = useSelector(getSports);




  // Get court details and price from the sports data
  const getCourtDetails = () => {
    const sport = sports.find(s => s.label === selectedSport);
    const court = sport?.options.find(c => c.value === selectedCourt);
    const format = court?.formats.find(f => f.value === selectedDuration);
    return {
      courtLabel: court?.label || '',
      price: format?.charges || 0
    };
  };


  const calculateEndTime = (startTime, durationMinutes) => {
    const [hours, minutes] = startTime.split(':');
    const startDate = new Date();
    startDate.setHours(parseInt(hours), parseInt(minutes), 0);

    const endDate = new Date(startDate.getTime() + durationMinutes * 60000);
    const endHours = endDate.getHours();
    const endMinutes = endDate.getMinutes();

    // Convert to 24-hour format first
    const endTimeStr = `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;

    // Now format both times to AM/PM
    return `${Common.Utility.formatTimeToAMPM(startTime)} - ${Common.Utility.formatTimeToAMPM(endTimeStr)}`;

  };

  const { courtLabel, price } = getCourtDetails();

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Checkout page"
        subTitle="Book your court"
        variant="text-center"
        href="/#"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="row">
          {/* Billing Details Section */}
          <div className="col-xl-7">
            {/* <p className="cs_checkout-alert m-0">
              Have a coupon?
              <Link to="/shop/checkout">Click here to enter your code</Link>
            </p> */}
            <Spacing lg="40" md="40" />
            <h2 className="cs_checkout-title">Billing Details</h2>
            <Spacing lg="40" md="40" />
            <div className="row">
              <div className="col-lg-6">
                <label className="cs_shop-label">First Name *</label>
                <input type="text" className="cs_shop-input" />
              </div>
              <div className="col-lg-6">
                <label className="cs_shop-label">Last Name *</label>
                <input type="text" className="cs_shop-input" />
              </div>
              <div className="col-lg-6">
                <label className="cs_shop-label">Phone *</label>
                <input type="text" className="cs_shop-input" />
              </div>
              <div className="col-lg-6">
                <label className="cs_shop-label">Email address *</label>
                <input type="text" className="cs_shop-input" />
              </div>
              <div className="col-lg-12">
                <label className="cs_shop-label">City *</label>
                <select className="cs_shop-input">
                  <option value="States">Karachi</option>
                </select>
              </div>
              {/* <div className="col-lg-12">
                <label className="cs_shop-label">Street address *</label>
                <input
                  type="text"
                  className="cs_shop-input"
                  placeholder="House number and street name"
                />
                <input
                  type="text"
                  className="cs_shop-input"
                  placeholder="Apartment, suite, unit, etc (optional) "
                />
              </div> */}
            </div>
            <Spacing lg="45" md="45" />
          </div>

          {/*  Section */}
          <div className="col-xl-5">
            <div className="cs_shop-side-spacing">
              <div className="cs_shop-card">
                <h2>Your Booking</h2>
                <table>
                  <tbody>
                    <tr className="cs_semi_bold">
                      <td>Date</td>
                      <td className="text-end">{Common.Utility.formatDate(selectedDate)}</td>
                    </tr>
                    <tr>
                      <td>Sport</td>
                      <td className="text-end">{selectedSport}</td>
                    </tr>
                    <tr>
                      <td>Court</td>
                      <td className="text-end">{courtLabel}</td>
                    </tr>
                    <tr>
                      <td>Time</td>
                      <td className="text-end">
                        {calculateEndTime(selectedTime, selectedDuration)}
                      </td>
                    </tr>
                    <tr>
                      <td className="cs_semi_bold">Duration</td>
                      <td className="text-end">{selectedDuration} minutes</td>
                    </tr>
                    <tr className="cs_semi_bold">
                      <td>Court Charges</td>
                      <td className="text-end">Rs. {courtCharges}</td>
                    </tr>
                    <tr className="cs_semi_bold">
                      <td>Discount</td>
                      <td className="text-end">Rs. {0}</td>
                    </tr>
                    <tr className="cs_semi_bold">
                      <td>Total</td>
                      <td className="text-end">Rs. {0}</td>
                    </tr>
                    <tr colspam="2">
                      <a
                        href="/booking/success"
                        className="cs_product_btn cs_semi_bold w-100"
                      >
                        Proceed To Payment
                      </a>
                    </tr>
                   
             
              
                  </tbody>
                </table>
                <input
                  type="text"
                  className="cs_shop-input mt-4"
                  placeholder="Have a coupon? Enter your code "
                />
              </div>
              <Spacing lg="20" md="30" />

              {/* Payment Section */}
              {/* <div className="cs_shop-card">
                <h2>Payment</h2>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                            id="flexCheckDefault"
                            defaultChecked
                          />
                          <label
                            className="form-check-label m-0 cs_semi_bold"
                            htmlFor="flexCheckDefault"
                          >
                            Pay on Club
                          </label>
                        </div>
                        <p className="m-0 cs_payment_text">
                          Make your payment directly at the club upon arrival.
                          Enjoy a hassle-free booking experience with secure
                          on-site payment options.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Spacing lg="25" md="25" />
                <p className="m-0 cs_payment_text">
                  Your personal data will be used to process your booking,
                  enhance your experience, and comply with our{" "}
                  <a href>privacy policy</a>.
                </p>
                <Spacing lg="30" md="30" />

              </div> */}
              <Spacing lg="30" md="30" />
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="120" md="50" />
    </>
  );
}